<template>
  <div>
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12 pt-4>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left text-uppercase">Image</th>
                <th class="text-left text-uppercase">Product Name</th>
                <th class="text-left text-uppercase">Price</th>
                <th class="text-left text-uppercase">Offer Price</th>
                <th class="text-left text-uppercase">Category</th>
                <th class="text-left text-uppercase">Shop Name</th>
                <!-- <th class="text-left text-uppercase">Email</th> -->
                <th class="text-left text-uppercase">Created Date</th>
                <th class="text-left text-uppercase">Status</th>
                <th class="text-center text-uppercase">Change Status</th>
                <th class="text-left text-uppercase">Action</th>

                <!-- <th class="text-left">Reserved Seats</th>
                <th class="text-left">Free</th> -->
              </tr>
            </thead>
            <tbody>
              <!-- @click="
                  $router.push(
                    '/ProductInfo?product=' +
                      item._id +
                      '&shop=' +
                      item.sellerId.shopName
                  )
                " -->
              <tr
              @click="
                  $router.push(
                    '/groceryProductInfo?id=' +
                      item._id +
                      '&shop=' +
                      item.sellerId.shopName
                  )"
                v-for="(item, i) in productData"
                :key="i"
                style="cursor: pointer; height: 90px"
              >
                <td>
                  <v-layout justify-center wrap v-if="item.photo">
                    <v-flex align-self-center xs12 pb-2 v-if="item.photo">
                      <v-img
                        contain
                        max-height="80"
                        max-width="100"
                        :src="mediaURL + item.photo"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color=" #FDAC53"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-flex>
                    <v-flex align-self-center xs12 pb-2 v-else>
                      <v-img
                        max-height="80"
                        max-width="100"
                        :src="require('../../assets/images/no-image.png')"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color=" #FDAC53"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-flex>
                  </v-layout>
                </td>

                <td>{{ item.varientName }}</td>
                <td>{{ Number(item.price).toFixed(0) }}</td>
                <td>{{ Number(item.offerPrice).toFixed(2) }}</td>
                <td v-if="item.categoryId">{{ item.categoryId.name }}</td>
                <td v-else>-</td>

                <td v-if="item.sellerId">
                  {{ item.sellerId.shopName }}
                </td>
                <td v-else>-</td>
                <!-- <td> {{ item.email }}</td> -->
                <td>{{ item.create_date.slice(0, 10) }}</td>

                <td>{{ item.status }}</td>
                <td class="text-center">
                  <span v-if="item.status == 'Inactive'">
                    <v-btn
                      color="green"
                      @click.stop="(statusData = item), (statusDialog = true)"
                      small
                      outlined
                      ><span>Enable </span>
                    </v-btn>
                  </span>
                  <span v-else-if="item.status == 'Active'">
                    <v-btn
                      color="red"
                      @click.stop="(statusData = item), (statusDialog = true)"
                      small
                      outlined
                      ><span>Disable </span>
                    </v-btn></span
                  >
                  <span v-else>-</span>
                </td>
                <td>
                  <span>
                    <v-btn
                      color="red"
                      @click.stop="(deleteData = item), (deleteDialog = true)"
                      small
                      outlined
                      ><span>Delete</span>
                    </v-btn>
                  </span>
                </td>
                <!-- <td style="width: 5%">
                  <v-btn
                    color="green"
                    small
                    outlined
                    :to="
                      '/ProductInfo?product=' +
                      item._id +
                      '&shop=' +
                      item.sellerId.shopName
                    "
                  >
                    View
                  </v-btn>
                </td> -->
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-dialog v-model="deleteDialog" max-width="600px">
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              small
              pa-0
              py-0
              px-0
              v-on="on"
              v-bind="attrs"
              color="#FFFFFF"
              style="font-size: 15px"
              >mdi-trash-can-outline</v-icon
            >
          </template>
          <v-card>
            <v-card-title
              >Are you sure you want to remove this product</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="deleteDialog = false"
                >Cancel</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItem()">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>
    <v-layout wrap justify-center>
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            :length="pages"
            :total-visible="7"
            v-model="currentPage"
            color="#FDAC53"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog v-model="statusDialog" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          small
          pa-0
          py-0
          px-0
          v-on="on"
          v-bind="attrs"
          color="#FFFFFF"
          style="font-size: 15px"
          >mdi-trash-can-outline</v-icon
        >
      </template>
      <v-card>
        <v-card-title v-if="statusData.status == 'Active'"
          >Are you sure you want to disable this Product?</v-card-title
        >
        <v-card-title v-if="statusData.status == 'Inactive'"
          >Are you sure you want to enable this Product?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="statusDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="blue darken-1" text @click="changeStatus()">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: [
    "productData",
    "pages",
    "filter",
    "pageFilters",
    "prevRoute",
    "currentPage",
  ],
  // props: ["fromDate","toDate","programme"],
  data() {
    return {
      // pages: 0,
      // productData: [],
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      deleteDialog: false,
      deleteData: {},
      statusDialog: false,
      statusData: {},
    };
  },
  // watch: {
  //   currentPage() {
  //     this.winStepper();
  //   },
  // },

  // computed: {
  //   currentPage1() {
  //     if (this.currentPage)
  //      return this.currentPage;
  //   },
  // },
  watch: {
    fromDate() {
      // this.getData()
    },
    toDate() {
      // this.getData()
    },
    programme() {
      // this.getData()
    },
    currentPage() {
      // this.getData();
      this.winStepper();
    },
    pageFilters: {
      handler(val) {
        console.log(val.productType, "pro");
        if (val) this.storeUpdation();
      },
      deep: true,
    },
  },
  beforeMount() {
    // this.getData()
    // this.winStepper();
    if (this.prevRoute == "/ProductInfo" || this.prevRoute == "/editProduct")
      this.storeUpdation();
  },
  methods: {
    storeUpdation() {
      this.$store.commit("productPageFilters", this.pageFilters);
    },
    deleteItem() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/grocery/product/delete" ,
        headers: {
          token: localStorage.getItem("token"),
        },
        data:
        {
          id:this.deleteData.productId._id
        }
      })
        .then((response) => {
          if (response.data.status) {
            this.$emit("stepper", {
              getData: true,
            });
            this.deleteDialog = false;

            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.deleteDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;

          // this.errors.push(err);
        });
    },
    changeStatus() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/grocery/product/status/change",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          id: this.statusData.productId._id,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.$emit("stepper", {
              getData: true,
            });
            this.statusDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          } else {
            this.statusDialog = false;
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch(() => {
          this.appLoading = false;

          // this.errors.push(err);
        });
    },
    winStepper() {
      // console.log("step", this.currentPage);
      // alert("my call win comp")
      this.$emit("stepper", {
        currentPage: this.currentPage,
        pages: this.pages,
      });
    },
    // getData() {
    //   this.appLoading = true;
    //   axios({
    //     method: "POST",
    //     url: "/product/admingetlist",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //     data: {
    //       // from: this.fromDate,
    //       // to: this.toDate,
    //       // user: this.programme,
    //       // slotDetail: this.slotDetail,
    //       productStatus: this.filter,
    //       count: 12,
    //       page: this.currentPage,
    //     },
    //   })
    //     .then((response) => {
    //       if (response.data.status) {
    //         this.sellers = response.data.data;
    //         // this.reservationData = response.data.reservations;
    //         this.pages = response.data.totalPages;
    //         // this.excel = response.data.data;
    //         // this.json_data = this.excel;
    //         this.appLoading = false;
    //       } else {
    //         this.msg = response.data.msg;
    //       }
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       this.ServerError = true;
    //       console.log(err);
    //     });
    // },
    formatDate(item) {
      var dt = new Date(item);
      var year = dt.getFullYear();
      dt = dt.toString();
      var strTime = dt.slice(4, 10) + " " + year;
      return strTime;
    },
    formatTime(item) {
      if (!item) return;
      var hours = Number(item.split(":")[0]);
      var minutes = Number(item.split(":")[1]);
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
  },
};
</script>